/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { ButtonSubmit, Container, Content, Title } from '../../GlobalStyle'
import BoxShadow from '../components/BoxShadowDiv'
import { Format, Manual, Table, Total, TotalText, TotalTitle } from './style'

import { ProgressSpinner } from 'primereact/progressspinner'
import { useQuery } from 'react-query'
import api from '../../hooks/API'
import { DAS } from '../../hooks/Calculations'
import { Mask } from '../../hooks/Mask'
import { CurrencyInput } from '../../hooks/MaskInput'
import {
  useAddAppSales,
  useAddMethodsSales,
  useAddNotesSales,
  useUpdateExpenses,
} from '../../hooks/mutations'
import { reverseFormatMoney } from '../../hooks/removeFormat'
import { Input } from '../components/Input/style'
import TabGroup from '../components/Tab'
import { Toggle } from '../components/ToggleButton'

const Variables = () => {
  const [total, setTotal] = useState(0)
  const [totalApp, setTotalApp] = useState(0)
  const [automatic, setAutomatic] = useState(true)
  const [totalSales, setTotalSales] = useState(0)
  const [totalAppSum, setTotalAppSum] = useState(0)

  const { mutate: updateVariables } = useUpdateExpenses()

  //APP-----------
  const { isLoading: isLoadingApp, data: dataApp } = useQuery(['appSales'], () => api.getAppSales())
  const { mutate: addAppSales } = useAddAppSales()
  const handleSaveApp = () => {
    dataApps.map((item) => {
      const result = {
        meses: item.meses,
        nome: item.name,
        valorMensal: item.value,
        percentual: item.percent_tax,
        taxa: item.tax,
        part: item.part_tax,
      }
      addAppSales(result)
    })
    updateVariable()
  }

  const handleInputChangeApp = (event, index, value) => {
    const { name } = event.target

    const list = [...dataApps]
    const mensalValue = reverseFormatMoney(list[index]['value'])
    const percent_tax = (mensalValue / totalAppSum) * 100

    const part_tax = (percent_tax * value) / 100

    list[index][name] = value
    list[index]['part_tax'] = part_tax

    setDataApp(list)
  }

  //METODOS ----------------------------------
  const {
    isLoading,
    data: fixed,
    isSuccess: isSuccessVariables,
  } = useQuery(['methodsSales'], () => api.getMethodsSales())
  const {
    isSuccess,
    data: salesData,
    isLoading: isLoadingFixed,
  } = useQuery(['fixedSales'], () => api.getFixedSalesExpenses())

  const [data, setData] = useState([{ name: '', value: 0, tax: 0, percent_tax: 0, part_tax: 0 }])

  const [dataApps, setDataApp] = useState([
    { name: '', value: 0, tax: 0, percent_tax: 0, part_tax: 0 },
  ])

  useEffect(() => {
    // Calculate the total sum of all values whenever data changes
    let sum = 0
    data?.forEach((item) => {
      sum += item.part_tax
    })

    automatic ? setTotal(sum) : null
  }, [data, automatic])

  useEffect(() => {
    let sum = 0
    dataApps?.forEach((item) => {
      sum += item.part_tax
    })

    automatic ? setTotalApp(sum) : null
  }, [dataApps, automatic])

  const { mutate: addMethodsSales } = useAddMethodsSales()

  const handleInputChange = (event, index, value) => {
    const { name } = event.target

    const list = [...data]
    const mensalValue = reverseFormatMoney(list[index]['value'])
    const percent_tax = (mensalValue / totalSales) * 100

    const part_tax = (percent_tax * value) / 100

    list[index][name] = value
    list[index]['percent_tax'] = percent_tax
    list[index]['part_tax'] = part_tax

    setData(list)
  }

  const updateVariable = () => {
    updateVariables({
      variaveis: total + DASData.part_tax + totalApp,
    })
  }
  const handleSave = () => {
    data.map((item) => {
      const result = {
        meses: item.meses,
        nome: item.name,
        valorMensal: item.value,
        taxa: item.tax,
        percentual: item.percent_tax,
        part: item.part_tax,
      }
      addMethodsSales(result)
    })
    updateVariable()
  }
  //NOTAS FISCAIS ----------------------------------
  const { isLoading: isLoadingNotes, data: notesData } = useQuery(['notesSales'], () =>
    api.getWithNotes()
  )

  const [DASData, setDASData] = useState({ value: 0, tax: 0, part_tax: 0 })
  const { mutate: addNotesSales } = useAddNotesSales()
  const handleDAS = (event, value) => {
    const { name } = event.target
    if (name === 'value') {
      const tax = DASData.tax
      const part_tax = (value / (totalSales / 3)) * tax

      setDASData((prevState) => ({ ...prevState, [name]: value }))
      setDASData((prevState) => ({ ...prevState, ['part_tax']: part_tax }))
    } else setDASData((prevState) => ({ ...prevState, [name]: value }))
  }

  useEffect(() => {
    if (notesData) {
      setDASData({
        id: notesData?.id,
        meses: [notesData.mes_1, notesData.mes_2, notesData.mes_3],
        name: notesData.nome,
        value: notesData.mes_3,
        tax: DAS((notesData.valor / 3) * 12),
        percent_tax: notesData.percentual,
        part_tax: notesData.part,
      })
      console.log(notesData)
    }
  }, [notesData])

  const handleSaveDAS = () => {
    const result = {
      meses: DASData.meses,
      nome: DASData.name,
      valorMensal: DASData.value,
      taxa: DASData.tax,
      percentual: DASData.percent_tax,
      part: DASData.part_tax,
    }
    addNotesSales(result)
    updateVariable()
  }

  //GERAL ----------------------------------

  const calcularSoma = (array) => {
    console.log(array)
    let soma = array?.reduce(
      (acc, curr) => {
        acc.mes_1 += curr.mes_1
        acc.mes_2 += curr.mes_2
        acc.mes_3 += curr.mes_3
        return acc
      },
      { mes_1: 0, mes_2: 0, mes_3: 0 }
    )
    return soma
  }

  const [tab, setTab] = useState(1)

  useEffect(() => {
    let sum = 0
    if (fixed) {
      const data = calcularSoma(fixed)
      sum += data?.mes_1 + data?.mes_2 + data?.mes_3
      setTotalSales(sum)
    }

    sum = 0
    if (dataApp) {
      const data = calcularSoma(dataApp)
      sum += data?.mes_1 + data?.mes_2 + data?.mes_3
      setTotalAppSum(sum)
    }
  }, [fixed, dataApp])
  useEffect(() => {
    if (!isLoadingApp) {
      const transformedData = dataApp?.map((item) => ({
        id: item.id,
        meses: [item.mes_1, item.mes_2, item.mes_3],
        name: item.nome,
        value: item.valor,
        tax: item.taxa,
        part_tax: item.part,
        percent_tax: item.percentual,

        // percent_tax: Mask.percent((item.valor / totalSales) * 100),
        //part_tax: Mask.percent(((item.valor / totalSales) * 100 * item.taxa) / 100),
      }))
      setDataApp(transformedData)
    }
  }, [fixed])

  useEffect(() => {
    if (isSuccessVariables) {
      const transformedData = fixed?.map((item) => ({
        id: item.id,
        meses: [item.mes_1, item.mes_2, item.mes_3],
        name: item.nome,
        value: item.valor,
        tax: item.taxa,
        part_tax: item.part,
        percent_tax: item.percentual,
        // percent_tax: Mask.percent((item.valor / totalSales) * 100),
        //part_tax: Mask.percent(((item.valor / totalSales) * 100 * item.taxa) / 100),
      }))

      setData(transformedData)
    }
  }, [dataApp, fixed])

  if (isLoading || isLoadingNotes || isLoadingApp)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )

  return (
    <Content>
      <Title>Despesas Variáveis</Title>
      <BoxShadow overflow={'initial'} minWidth={'500px'}>
        <TabGroup setTab={setTab} info={DASData.part_tax + total + totalApp} />

        {/*PÁGINA DE METODOS */}

        {tab == 1 ? (
          <Container>
            <Total>
              <TotalTitle>{automatic ? 'Despesas por mês' : 'Despesa manual'}</TotalTitle>
              <Format>
                <p>Automático</p>
                <Toggle toggled={true} onClick={() => setAutomatic(!automatic)} />
              </Format>

              <TotalText>
                <span>%</span>
                {Mask.percent(total).slice(2)}
              </TotalText>
            </Total>

            {automatic ? (
              <>
                <Table>
                  <thead>
                    <tr>
                      <th>Método de pagamento</th>
                      <th>Valor</th>
                      <th>Taxa</th>
                      <th>%</th>
                      <th>PART %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <Input type="text" name="name" value={item.name} disabled />
                        </td>
                        <td>
                          <CurrencyInput type="text" name="value" value={item.value} disabled />
                        </td>
                        <td>
                          <CurrencyInput
                            currency={'percent'}
                            type="text"
                            name="tax"
                            value={item.tax}
                            onChangeValue={(event, originalValue) =>
                              handleInputChange(event, index, originalValue)
                            }
                          />
                        </td>
                        <td>
                          <CurrencyInput
                            currency={'percent'}
                            type="text"
                            name="percent_tax"
                            value={item.percent_tax}
                            disabled
                          />
                        </td>
                        <td>
                          <CurrencyInput
                            currency={'percent'}
                            type="text"
                            name="part_tax"
                            value={item.part_tax}
                            disabled
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            ) : (
              <Manual>
                <p>Informe a despesa variável</p>
                <CurrencyInput
                  currency={'percent'}
                  value={total}
                  onChange={(e, originalValue) => setTotal(originalValue)}
                  width={'30%'}
                ></CurrencyInput>
              </Manual>
            )}

            <ButtonSubmit margin={'15px 0px 0px 0px'} onClick={handleSave}>
              Salvar
            </ButtonSubmit>
          </Container>
        ) : tab == 2 ? (
          <>
            {/*PÁGINA DE APP/PLATAFORMAS */}

            <Container>
              <Total>
                <TotalTitle>DESPESAS DO APP</TotalTitle>

                <TotalText>
                  <span>%</span>
                  {Mask.percent(totalApp).slice(2)}
                </TotalText>
              </Total>

              <Table>
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Valor</th>
                    <th>Taxa</th>
                    <th>PART %</th>
                  </tr>
                </thead>
                <tbody>
                  {dataApps?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Input
                          type="text"
                          name="name"
                          value={item.name == 'withApp' ? 'Vendas com App' : 'Vendas online'}
                          disabled
                        />
                      </td>
                      <td>
                        <CurrencyInput type="text" name="value" value={item.value} disabled />
                      </td>
                      <td>
                        <CurrencyInput
                          type="text"
                          name="tax"
                          currency={'percent'}
                          value={item.tax}
                          onChangeValue={(event, originalValue) =>
                            handleInputChangeApp(event, index, originalValue)
                          }
                        />
                      </td>

                      <td>
                        <CurrencyInput
                          currency={'percent'}
                          type="text"
                          name="part_tax"
                          value={item.part_tax}
                          disabled
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <ButtonSubmit margin={'15px 0px 0px 0px'} onClick={handleSaveApp}>
                Salvar
              </ButtonSubmit>
            </Container>
          </>
        ) : (
          <>
            {/*PÁGINA DAS */}
            <Container>
              <Total>
                <TotalTitle>DAS</TotalTitle>

                <TotalText>
                  <span>%</span>
                  {Mask.percent(DASData.part_tax).slice(2)}
                </TotalText>
              </Total>

              <Table>
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th>Valor</th>
                    <th>Taxa</th>
                    <th>PART %</th>
                    <th>Valor em 12 meses (Notas)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Input type="text" name="name" value={'Vendas fiscais'} disabled />
                    </td>
                    <td>
                      <CurrencyInput
                        type="text"
                        name="value"
                        value={DASData.value}
                        onChangeValue={(event, originalValue) => handleDAS(event, originalValue)}
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        currency={'percent'}
                        type="text"
                        name="tax"
                        value={DASData.tax}
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        currency={'percent'}
                        type="text"
                        name="part_tax"
                        value={DASData.part_tax}
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        type="text"
                        name="totalSales"
                        value={(notesData?.valor / 3) * 12}
                        disabled
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>

              <ButtonSubmit margin={'15px 0px 0px 0px'} onClick={handleSaveDAS}>
                Salvar
              </ButtonSubmit>
            </Container>
          </>
        )}
      </BoxShadow>
    </Content>
  )
}
export default Variables
